import './locales/register'
import './page-slots'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'

import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const Index = lazy(() => import('./components/Index'))
const List = lazy(() => import('./components/List'))

const WorkDayModule: RouteObject = {
    path: 'workdays',
    children: [
        {
            path: 'manage',
            element: <Index />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

const AccountWorkDayModule: RouteObject = {
    path: 'account/workdays',
    children: [
        {
            path: '',
            element: <List />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export { WorkDayModule, AccountWorkDayModule }
